<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('productAssembly.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('productAssembly.pageTitle'),
            active: true,
          },
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="ts-flex ts-justify-end ts-items-center">
          <ts-input
            v-tooltip="$t('productAssembly.search')"
            v-model="search"
            :placeholder="$t('search')"
            style="width: 250px;"
            class="inline-block"
          />
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
        >
          <template v-slot="{ record }">
            <td>{{ record.product.barcode }}</td>
            <td>{{ record.product.pro_group_name_en }}</td>
            <td>{{ record.product.product_name_kh }}</td>
            <td>{{ record.product.product_name_en }}</td>
            <td>{{ record.product.category_name_en }}</td>
            <td>{{ record.unit_of_measure.uom_name_en }}</td>
            <td class="ts-w-3">
              <span class="badge badge-success" v-if="record.assemblies_count">Yes</span>
              <span class="badge badge-danger" v-else>No</span>
            </td>
						<td class="text-center">
							<a href="#" 
								v-tooltip="$t('add_new')"
								@click.prevent="chosen(record)"
							>
								<i class="fa fa-plus"></i>
							</a>
						</td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
      </div>
    </ts-card>
		<a-modal v-model="showForm" 
			:title="$t('productAssembly.pageTitle')" 
			:footer="null"
			:maskClosable="false"
			:zIndex="1020"
			width="50%"
		>
			<FormComponent 
        :saleCodeId="saleCodeId"
        @cancel="onCancel"
      />
    </a-modal>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState, mapActions } from 'vuex'
import FormComponent from './components/form'

export default {
	name: 'profileIndex',
	components: {
		FormComponent
	},
  data() {
    return {
      loading: false,
      showForm: false,
      saleCodeId: null
    }
  },
  computed: {
    ...mapState('product/assembly', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.product.assembly.search
      },
      set(newValue) {
        this.$store.commit('product/assembly/SET_SEARCH', newValue)
        this.$store.commit('product/assembly/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name:  this.$t('productAssembly.barcode'), style: 'width: 11%' },
        { name:  this.$t('productAssembly.group')},
        { name:  this.$t('productAssembly.nameKh')},
        { name:  this.$t('productAssembly.nameEn')},
        { name:  this.$t('productAssembly.category')},
        { name:  this.$t('productAssembly.uom')},
        { name:  this.$t('productAssembly.recipes')},
        { name: this.$t('actions'), style: 'text-align:center; width:80px' }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('product/assembly/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
		},
		chosen(record){
      this.showForm = true
      this.saleCodeId = record.pro_sale_code_id
    },
    onCancel(){
      this.showForm = false
      this.fetchData()
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData()
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('product/assembly/RESET_STATE')
    this.$store.commit('product/assembly/CLEAR_SETUP')
    next()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  }
}
</script>